<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 class="fs-1x fw-bolder mb-10">Lista de Usuarios</h2>
        <p class="text-gray-600 fs-6 fw-bold mb-5">
          <span>
            <button type="button" class="btn btn-primary px-3" @click="newUser">
              <i title="Ver resolución" class="fas fa-plus"></i> Nuevo ingreso
            </button>
          </span>
        </p>

        <div class="row">
          <DxDataGrid
            id="gridContainer"
            ref="dataGridRef"
            :data-source="usersList"
            key-expr="id_usuario"
            :allow-column-reordering="false"
            :row-alternation-enabled="true"
            :show-borders="true"
            :column-auto-width="true"
          >
            <!-- Inicio de Complementos para el datatable -->
            <DxFilterRow :visible="true" />
            <DxSearchPanel :visible="true" />
            <DxPaging :page-size="10" />
            <DxPager :visible="true" :show-page-size-selector="true" />
            <!-- <DxGroupPanel :visible="true" /> -->
            <!-- <DxGrouping :auto-expand-all="false" /> -->
            <!-- <DxSelection mode="multiple" /> -->
            <!-- Fin de Complementos para el datatable -->
            <DxColumn
              :width="180"
              :allow-sorting="false"
              caption="Acciones"
              cell-template="cellTemplate"
            />
            <template #cellTemplate="{ data }">
              <button
                type="button"
                class="btn btn-outline-primary"
                title="Editar Usuario"
                @click="readUser(data.data.id_usuario)"
              >
                <i class="fas fa-edit"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                title="Inhablitar Usuario"
                v-if="data.data.id_estado_usuario == 1"
                @click="dismissUser(data.data.id_usuario)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </template>
            <DxColumn
              :width="250"
              :allow-sorting="true"
              caption="Rol"
              data-field="nombre_rol"
            />
            <DxColumn
              :width="250"
              :allow-sorting="true"
              caption="Nombres"
              data-field="nombres"
            />
            <DxColumn
              :width="250"
              :allow-sorting="true"
              caption="Primer Apellido"
              data-field="primer_apellido"
            />
            <DxColumn
              :width="250"
              :allow-sorting="true"
              caption="Segundo Apellido"
              data-field="segundo_apellido"
            />
            <DxColumn
              :width="250"
              :allow-sorting="false"
              caption="Número de Documento"
              data-field="nro_documento"
            />
            <DxColumn
              :width="250"
              :allow-sorting="false"
              caption="Institución"
              data-field="institucion_pertenece"
            />
            <DxColumn
              :width="250"
              :allow-sorting="false"
              caption="Cargo"
              data-field="cargo"
            />
            <DxColumn
              :width="250"
              :allow-sorting="false"
              caption="Correo Electronico"
              data-field="correo_electronico"
            />
            <DxColumn
              :width="250"
              :allow-sorting="false"
              caption="Nombre de Usuario"
              data-field="nombre_usuario"
            />
            <DxColumn
              :width="250"
              :allow-sorting="false"
              caption="Recinto Penitenciario"
              data-field="nombre_recinto_penitenciario"
            />
            <DxColumn
              :width="250"
              :allow-sorting="false"
              caption="Departamento supervisar"
              data-field="departamento_supervisar"
            />
          </DxDataGrid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { defineComponent, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import {
  DxDataGrid,
  DxFilterRow,
  DxColumn,
  DxExport,
  DxSelection,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxPaging,
  DxPager,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  //DxButton,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import "devextreme/dist/css/dx.light.css";

import user from "@/user/composables/useUser";
export default defineComponent({
  name: "listUser",
  components: {
    DxDataGrid,
    DxSearchPanel,
    DxColumn,
    DxPaging,
    DxFilterRow,
    DxPager,
  },
  setup() {
    const router = useRouter();

    const usersList = ref([]);

    const { users, infoUser, deleteUser } = user();

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });

    const listUsers = async () => {
      const data = await users();
      if (data.message) {
        // console.log(data.message.response.data)
        // MOSTRAR AVISO Y REDIRECCIONAR AL DASHBOARD
        /*
            router.push({ name: "dashboard" })
            Toast.fire({
                icon: 'error',
                title: data.message.response.data.message,
            })
            */
      } else {
        return (usersList.value = data.data);
      }
    };

    const readUser = async (data) => {
      await infoUser(data);
      // console.log(data)
      router.push({ name: "readUser", params: { id: data } });
    };

    const newUser = () => {
      router.push({ name: "readUser", params: { id: "0" } });
    };

    const dismissUser = async (data) => {
      // SE DEBE LANZAR UNA CONFIRMACION DE ESTO
      // await deleteUser(data)
      // router.go()
      Swal.fire({
        title: "¿Está seguro?",
        text: "No se podra revertir el cambio",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si, inhabilitar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // EJECUTAMOS LOS QUERIES
          // console.log('eliminado', data)
          await deleteUser(data);
          Swal.fire("Inhabilitado!", "El usuario fue inhabilitado.", "success");
          await listUsers();
        }
      });
    };

    onMounted(() => {
      listUsers();
    });

    // onBeforeMount(() => {
    // listUsers()
    // })

    return {
      newUser,
      readUser,
      listUsers,
      dismissUser,
      usersList,
    };
  },
});
</script>

<style></style>
